import { useMemo, useState } from "react";
import usePrecoRegra from "~/fetchs/usePrecoRegra";
import ContainerDaTabelaPrecoPrecoRegra from "~pages/PricesTableV2/components/Tabela/ContainerDaTabelaPrecoRegra";
import { FormProvider, useForm } from "react-hook-form";
import { getStoragekeysRules } from "~pages/PricesTableV2/helpers/storage";
import FiltroPrazo from "~pages/PricesTableV2/components/filters/FiltroPrazo";

const PriceRuleByTerm = () => {
  const keys = useMemo(() => getStoragekeysRules("filtroPrazo"), []);

  const getDefaultValues = () => {
    try {
      const savedGrupoProduto = localStorage.getItem(keys.grupoProduto);

      const savedSegmento = localStorage.getItem(keys.segmento);

      const savedFamilia = localStorage.getItem(keys.familia);

      return {
        grupoProduto: savedGrupoProduto ? JSON.parse(savedGrupoProduto).value : 0,

        grupoSegmento: savedSegmento ? JSON.parse(savedSegmento).value : 0,

        familia: savedFamilia ? JSON.parse(savedFamilia).value : 0,
      };
    } catch (error) {
      console.warn("Error loading filters from localStorage:", error);
      return {
        grupoProduto: 0,
        grupoSegmento: 0,
        familia: 0,
      };
    }
  };

  const methods = useForm({
    defaultValues: getDefaultValues(),
  });

  const grupoProduto = methods.watch("grupoProduto");

  const grupoSegmento = methods.watch("grupoSegmento");

  const familia = methods.watch("familia");

  const filters = useMemo(
    () => ({
      familia: familia || 0,
      grupoProduto: grupoProduto || 0,
      grupoSegmento: grupoSegmento || 0,
    }),
    [grupoProduto, grupoSegmento, familia]
  );

  const [onFiltros] = useState({
    produto: false,
    grupoDeProduto: false,
    centro: false,
    cidade: false,
    microrregiao: false,
    grupoSegmento: false,
    segmento: false,
    cluster: false,
    familia: false,
  });

  const [loading, setLoading] = useState(false);
  const [skip, setSkip] = useState(0);
  const [take] = useState(10);

  const { precosRegra, total, filtrosDisponiveisPrecoRegra, totalRenderizado } = usePrecoRegra({
    filters: filters,
    setLoading,
    skip,
    take,
  });

  return (
    <>
      <FormProvider {...methods}>
        <FiltroPrazo filtrosDisponiveis={filtrosDisponiveisPrecoRegra} nomeDoFiltro={"filtroPrazo"} loading={loading} />
      </FormProvider>

      <ContainerDaTabelaPrecoPrecoRegra
        filters={filters}
        onFiltros={onFiltros}
        estadoFiltro={1}
        total={total}
        precosRegra={precosRegra}
        loading={loading}
        setLoading={setLoading}
        setSkip={setSkip}
        take={take}
        totalRenderizado={totalRenderizado}
      />
    </>
  );
};

export default PriceRuleByTerm;
